module.exports = __webpack_public_path__ + "static/facebook-2048-black-4c25d18059353799aff91dcdd8f19bb4.png";